import React, { FC } from 'react';
import { getNameInitials } from '@src/util/getNameInitials';
import { relativeTime } from '@src/util/relativeTime';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { QueryParams } from '@src/containers/Source/interfaces/queryParams.interface';
import { GroupedTalentDictionaryKey } from '@src/containers/Source/constants/groupedTalentDictionary/enums/groupedTalentDictionaryKey.enum';
import { FeedItemVisibilityWrapper } from '@src/components/FeedItemVisibilityWrapper';
import { TalentListItem } from './TalentListItem';
import { TalentListItemSkeleton } from './TalentListItem/TalentListItemSkeleton';
import { TalentListProps } from './props';
import './styles.scss';

export const TalentList: FC<TalentListProps> = ({ list, onTalentClick, isLoading }) => {
  const { queryParams } = useQueryParams<QueryParams>();

  const isInactiveSubscription = false;
  // const customerStatus = useAppSelector(getCustomerStatus);
  // Allowing to use the feature for all users for now
  // const isInactiveSubscription =  !!isSubscriptionPlanType(planInfo) && !!planInfo.state && !!INACTIVE_SUBSCRIPTION_STATES.includes(planInfo.state);

  const groupedTalentsKey = queryParams.groupedTalentsKey;

  return (
    <div className="talent-pipeline-sidebar-list">
      {list?.map((talent, index) => {
        const originalSalaryValue = talent.user.profile.originalSalary.value || undefined;
        const originalSalaryCurrency = talent.user.profile.originalSalary.currency.symbol || undefined;

        const expectedSalary =
          originalSalaryValue && originalSalaryCurrency
            ? `${originalSalaryValue} ${originalSalaryCurrency}`
            : undefined;

        const locationNames = [
          talent.user.profile.location.shortName,
          ...(talent.user.profile.isRemote ? ['Remote'] : []),
          ...(talent.user.profile.isRelocation ? ['Relocation'] : []),
        ];

        const timestamp =
          groupedTalentsKey === GroupedTalentDictionaryKey.RECENTLY_ACTIVE
            ? talent.user.lastSeenAt
            : talent.userVerification.publishedAt;

        const isActive = queryParams?.userId === talent.user.id || (!queryParams?.userId && index === 0);

        return (
          <div className="talent-pipeline-sidebar-list__talent" key={talent.user.id}>
            <FeedItemVisibilityWrapper>
              <TalentListItem
                avatarColor={talent.user.avatarColor || undefined}
                avatarUrl={talent.user.avatar?.fullUrl || undefined}
                expectedSalary={expectedSalary}
                isActive={isActive}
                isContentHidden={isInactiveSubscription}
                locationNames={locationNames}
                message={talent.userVerification.positionExpectations || undefined}
                nameInitials={getNameInitials(talent.user.name)}
                onClick={() => onTalentClick(index, talent.user.id)}
                timeStamp={relativeTime(timestamp, true)}
                title={talent.user.position || undefined}
              />
            </FeedItemVisibilityWrapper>
          </div>
        );
      })}

      {isLoading &&
        [0, 1, 2].map(item => {
          return <TalentListItemSkeleton key={item} />;
        })}

      {!isLoading && !list?.length && (
        <div className="talent-pipeline-sidebar-list__empty-state">No results to display.</div>
      )}
    </div>
  );
};
